import { getToken } from "../../../services/authService";

const API = process.env.REACT_APP_API_URL;

const authHeaders = () => {
    const t = getToken();
    return { Authorization: `Bearer ${t}` };
};

export async function fetchPersonasAll() {
    const res = await fetch(`${API}/api/personas/all`, { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
